/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Voice_SoftInputs */

const en_dialog_voice_soft = /** @type {(inputs: Dialog_Voice_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft voice`)
};

const es_dialog_voice_soft = /** @type {(inputs: Dialog_Voice_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz suave`)
};

/**
* | output |
* | --- |
* | "Soft voice" |
*
* @param {Dialog_Voice_SoftInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_voice_soft = /** @type {((inputs?: Dialog_Voice_SoftInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Voice_SoftInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_voice_soft(inputs)
	return en_dialog_voice_soft(inputs)
});